import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useApiClient } from "../../api";
import { LIST_DOCUMENTS_QUERY_KEY } from "../queries/useListDocuments";

export const useArchiveDocument = () => {
  const client = useApiClient();
  const queryClient = useQueryClient();

  const mutationFn = (documentId: string) => {
    return client.api.archiveDocument({ docId: documentId });
  };

  return useMutation({
    mutationFn,
    async onSuccess() {
      await queryClient.invalidateQueries({ queryKey: [LIST_DOCUMENTS_QUERY_KEY] });
    },
  });
};
